import React, { useContext } from "react";
import PropTypes from "prop-types";
import { store } from "~/Context/JukeboxContext";
import axios from "axios";
import classNames from "classnames";

import { Link } from "react-router-dom";
import dayjs from "dayjs";
import "./TrackBox.less";
import TrackImage from "./Global/TrackImage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPause } from "@fortawesome/free-solid-svg-icons";
import { mediaType } from "./../../utils/media";

const textLargeVariant = 30;

const TrackBox = (props) => {
  const { track } = props;
  const globalState = useContext(store);

  const {
    dispatch,
    state: { playing },
  } = globalState;

  const date = dayjs(track.date).format("MMMM D, YYYY");
  const audioFormatClassName = track.sc_url && `audio-format-${mediaType(track.sc_url)}` || 'audio-format-none';

  const textLength = track.title.length + track.artist.length;
  const textClass = textLength > textLargeVariant ? `img-box-text img-box-text-sm` : `img-box-text img-box-text-lg`;

  const isThisTheCurrentTrack = () => globalState.state.currentTrack && globalState.state.currentTrack.id == track.id;

  const playTrack = async () => {
    if (playing && isThisTheCurrentTrack()) {
      dispatch({ type: "pause" });
    } else {
      await axios.get(`//api.dreamchimney.com/playlist-track?id=${track.id}`).then(({ data }) => {
        if (data && data[0] && data[0].tracks.length) dispatch({ type: "play_playlist", playlist: data[0] });
      });
    }
  };
  const wrapperClass = classNames({
    "track-img-box": true,
    [`${audioFormatClassName}`]: true,
  });
  return (
    <div className={wrapperClass}>
      <div>{date}</div>
      <TrackImage track={track} width={null} />
      <Link to={`/${track.id}`} className={textClass}>
        "{track.title}" by {track.artist}
      </Link>
      {track.media_id && (<div style={{ position: 'absolute', bottom: 0, right: 0 }}>
        <button onClick={playTrack} title="Play track in the jukebox below">
          {(playing && isThisTheCurrentTrack() && <FontAwesomeIcon className="pause-icon" icon={faPause} />) || (
            <FontAwesomeIcon className="play-icon" icon={faPlay} />
          )}
        </button>
      </div>)}

    </div>
  );
};

TrackBox.propTypes = {
  track: PropTypes.object.isRequired,
};

export default TrackBox;
